import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";

export const PostPurchaseEmailToggle = () => (
  <Form.Item
    className="!mt-0 !py-0"
    name="post_purchase_email_enabled"
    translationRoot="settings.paywalls.modal.tabs.post_purchase"
    inline
    tooltipText={t(
      "settings.paywalls.modal.tabs.post_purchase.post_purchase_email_enabled_tooltip",
    )}
    hideDescription
    hideBorder
    labelClassName="text-xl tightest font-semibold"
  >
    <Form.ToggleSwitch variant="large" name="post_purchase_email_enabled" />
  </Form.Item>
);
